import { Button, FormControlSizes, IconName, Popover, useDisclosure, usePopoverState, VStack } from '@talos/kyoko';
import { useCallback, useState } from 'react';
import { useFeatureFlag } from '../../../../hooks';
import { useBaskets } from '../../../../providers/BasketsProvider';
import { BasketDetailsImportDialog } from './BasketDetailsImportDialog';
import { CurrentBasketDetailsDialog } from './CurrentBasketDetailsDialog';

export const BasketDetailsImportButton = () => {
  const currentBasketDetailsDialog = useDisclosure();
  const csvImportBasketDetailsDialog = useDisclosure();

  const { enableImportBasketDetailsUnqork } = useFeatureFlag();

  const popover = usePopoverState({ placement: 'bottom', trigger: 'click', closeOnClickOutside: true });

  const [apiImportLoading, setAPIImportLoading] = useState(false);
  const { apiRefreshBaskets } = useBaskets();

  const handleAPIImportClick = useCallback(() => {
    setAPIImportLoading(true);
    apiRefreshBaskets().finally(() => {
      setAPIImportLoading(false);
    });
  }, [apiRefreshBaskets]);

  return (
    <>
      <Popover {...popover}>
        <Button
          startIcon={IconName.DocumentUpload}
          size={FormControlSizes.Small}
          data-testid="import-basket-details-button"
        >
          Import Basket Details
        </Button>
        <VStack w="120px" alignItems="flex-start" gap="spacing4">
          <Button
            size={FormControlSizes.Small}
            width="100%"
            onClick={() => {
              currentBasketDetailsDialog.open();
              popover.close();
            }}
            data-testid="show-current-basket-details-button"
          >
            Show current
          </Button>
          {enableImportBasketDetailsUnqork && (
            <Button
              size={FormControlSizes.Small}
              width="100%"
              onClick={handleAPIImportClick}
              loading={apiImportLoading}
              data-testid="api-import-basket-details-button"
            >
              API Import
            </Button>
          )}
          <Button
            size={FormControlSizes.Small}
            width="100%"
            onClick={() => {
              csvImportBasketDetailsDialog.open();
              popover.close();
            }}
            data-testid="csv-import-basket-details-button"
          >
            CSV Import
          </Button>
        </VStack>
      </Popover>
      <BasketDetailsImportDialog {...csvImportBasketDetailsDialog} />
      {/* There's something strange with AgGrid mounting and unmounting in our dialogs so hard-reset it upon opening/closing */}
      {currentBasketDetailsDialog.isOpen && <CurrentBasketDetailsDialog {...currentBasketDetailsDialog} />}
    </>
  );
};
